define ['./pay.scss'], () ->
  ($scope, $rootScope, $state, $stateParams, $http, $anchorScroll, $location, $cacheFactory, Flash, RentappService, RENTAPPLICATION_API_URL) ->
    
    

    $scope.report_amount = _.reduce($scope.application.reports, (sum, n) ->
      if n.status == 'sent_payment_request'
        return sum + n.report_source_profile.price
      else
        return sum
    , 0)
    $scope.sales_tax_rate = parseFloat($scope.application.sales_tax_rate) or 0
    $scope.sales_tax_amount = $scope.sales_tax_rate * $scope.report_amount

    $scope.total_fees = $scope.report_amount + $scope.sales_tax_amount 

    $scope.reports_need_payment = _.filter($scope.application.reports, (report) ->
      return report.status == 'sent_payment_request'
    )

    $scope.submit_payment = () ->
      $scope.submitting_payment = true

      RentappService.getStripe().then((stripe) ->
        stripe.createToken($scope.card)
          .then((result) ->
            if result.error
              $scope.submitting_payment = false
              $rootScope.$broadcast("card-error", result.error)
            else
              token = result.token.id
              $http.post "#{RENTAPPLICATION_API_URL}/api/v1/application/#{$stateParams.application_id}/buy_reports_by_applicant/",
                stripeToken: token
                payment_receipt: $scope.card.payment_receipt
              .then (response) ->
                $scope.submitting_payment = false
                $cacheFactory.get('$http').removeAll()
                $state.go "root.payment.complete"
              .catch (error) ->
                $rootScope.$broadcast("submit-error", {
                  action: "pay"
                  app_id: $stateParams.application_id
                  response: error
                })
                Flash.create('danger', error.data.message, 6000)
                $scope.submitting_payment = false
                $anchorScroll.yOffset = 100;
                $location.hash('error_messge')
                $anchorScroll()
          )
      )



// WEBPACK FOOTER //
// ./components/payment/pay/pay.coffee